import { user, initialize } from "cosmos";
import { getUserCosmos, getOrgId } from "./helper";

/**
 * initCosmos is a function used to call initialize method of SDK
 * which will initialize SDK. We can set configuration here.
 * Can also pass rest attributes.
 */
export const initCosmos = () => {
  let initialConfig = {
    eventLimit: 1,
    logging: true,
    env:
      import.meta.env.VITE_ENV === "PROD"
        ? "production"
        : import.meta.env.VITE_ENV,
    // uncomment debug to disable cosmos
    // debug: true,
  };
  /* Attributes you want to append in each user session call */
  let restAttributes = { source: 53, source_app: "classplus" };
  let org_id = getOrgId();
  let prev_org_id = +localStorage.getItem("org_id");
  if (org_id && prev_org_id && org_id !== prev_org_id) {
    // log out cosmos
    user.logout();
  }
  localStorage.setItem("org_id", org_id);
  updateUserCosmos();
  /*
   This function will call initialize fn of cosmos SDK
   initialize function expects optional config object which 
   is the configuration you want to set for SDK 
  */
  initialize(initialConfig, restAttributes);
};

/**
 * This function is used to call login method
 * of Cosmos SDK.
 * We can pass userAttributes as a param to SDK
 * login method.
 */
export const loginCosmos = () => {
  const userAttributes = getUserCosmos();
  user.login(userAttributes);
};

export const logoutCosmos = () => {
  /* Will clear token and userAttributes. */
  user.logout();
};

/**
 * This function is used to set user attributes
 * inside Cosmos SDK.
 */
export const updateUserCosmos = (userAttr = {}) => {
  const userAttributes = getUserCosmos();
  const updatedUserAttributes = { ...userAttributes, ...userAttr };
  user.updateAttributes(updatedUserAttributes);
};
